@tailwind base;
@tailwind components;
@tailwind utilities;

/* ── Base reset ─────────────────────────────────────────────────────────────── */
@layer base {
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body, #root {
    height: 100%;
    overflow: hidden;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #d3d4d9;
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #737578;
  }
}

/* ── Mapbox overrides ────────────────────────────────────────────────────────── */
.mapboxgl-ctrl-bottom-right {
  @apply opacity-50;
}
.mapboxgl-popup-content {
  @apply rounded-xl border border-neutral-200 bg-document p-4 text-ink shadow-2xl;
  background-color: #eef2fa !important;
  color: #232323 !important;
}
.mapboxgl-popup-tip {
  border-top-color: #eef2fa !important;
}

/* ── Temporal slider — custom range input ────────────────────────────────────── */
.temporal-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  border: 2px solid #003cc5;
  cursor: pointer;
  pointer-events: all;
}
.temporal-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
  border: 2px solid #003cc5;
  cursor: pointer;
  pointer-events: all;
}

/* ── Timeline narrative HTML ─────────────────────────────────────────────────── */
.narrative-content {
  color: #1c1b18;
  font-size: 0.875rem;
  line-height: 1.6;
}
.narrative-content p { margin-bottom: 0.75rem; }
.narrative-content h3 {
  font-size: 1rem;
  font-weight: 600;
  color: #1c1b18;
  margin: 1.25rem 0 0.5rem;
}
.narrative-content strong { font-weight: 600; color: #1c1b18; }
.narrative-content ul { list-style: none; margin: 0.5rem 0; padding: 0; }
.narrative-content li {
  border-left: 2px solid #e2dbd0;
  margin-bottom: 0.75rem;
  padding-left: 0.75rem;
}
.narrative-content blockquote {
  background: #f0ebe0;
  border-left: 3px solid #c0392b;
  border-radius: 0 0.375rem 0.375rem 0;
  color: #7a6e64;
  font-style: italic;
  margin: 0.5rem 0;
  padding: 0.5rem 0.75rem;
}
.narrative-content table {
  border-collapse: collapse;
  font-size: 0.8rem;
  margin-top: 0.75rem;
  width: 100%;
}
.narrative-content th, .narrative-content td {
  border: 1px solid #e2dbd0;
  padding: 0.375rem 0.625rem;
  text-align: left;
}
.narrative-content th {
  background: #f0ebe0;
  font-weight: 500;
  color: #1c1b18;
}

/* ── Line clamp utilities ────────────────────────────────────────────────────── */
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
